import React, { Component } from 'react'
import Label from './Label'

const types = {
  input: 'ncss-input-container',
  textarea: 'ncss-textarea-container',
  radio: 'ncss-radio-container',
  select: 'ncss-select-container',
  checkbox: 'ncss-checkbox-container',
  wiki: 'ncss-wiki-container'
}

const labelBeforeTypes = ['input', 'select', 'textarea', 'text', 'wiki']
const labelAfterTypes = ['radio', 'checkbox']

export default class InputContainer extends Component {
  render () {
    let type = this.props.type || 'input'
    let inputType = types[type]
    let { label, title, error, labelBefore, labelAfter } = this.props

    let children = React.Children.toArray(this.props.children)

    if (label) {
      let inputLabel = <Label key='label' title={title}>{label}</Label>
      if (labelBefore || (!labelAfter && labelBeforeTypes.includes(type))) {
        children.unshift(inputLabel)
      } else if (labelAfter || labelAfterTypes.includes(type)) {
        children.push(inputLabel)
      }
    }

    if (error) {
      children.push(<div className='ncss-error-msg' key='error'>{error}</div>)
    }

    return (
      <div className={`ncss-form-group ${this.props.extraClassName || ''}`}>
        <div className={`${inputType} ${error ? 'error' : ''}`}>
          {children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/src/components/ncss/InputContainer.js